'use strict';

app.directive('rmVideo', function ($sce, $timeout) {
  return {
    scope: {
      video: '=rmVideo',
      autoplay: '='
    },
    templateUrl: '/app/directives/rm-video/rm-video.html',
    link: function (scope) {

      var youtubeRegExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
      var vimeoRegExp = /\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;

      scope.$watch('video', function (video) {
        scope.playing = false;
        if (video && video.src) {
          var match = video.src.match(youtubeRegExp);
          if (match && match[1]) {
            scope.embed = $sce.trustAsResourceUrl('//www.youtube.com/embed/' + match[1] + '?autoplay=1');
            return;
          }
          match = video.src.match(vimeoRegExp);
          if (match && match[2]) {
            scope.embed = $sce.trustAsResourceUrl('//player.vimeo.com/video/' + match[2] + '?autoplay=1');
            return;
          }
        }
        scope.embed = 'about:blank';
      });

      scope.play = function () {
        scope.playing = true;
      };

      if (scope.autoplay) {
        $timeout(function () {
          scope.playing = true;
        }, 100);
      }

    }
  };
});

